import React from 'react';
import ShapeThumbnail from './ShapeThumbnail';

const IconThumbnail = ({ svg, alt = '', size = 80, innerScale = 0.6, className = '' }) => (
  <ShapeThumbnail
    svgContent={svg}
    alt={alt}
    size={size}
    innerScale={innerScale}
    className={className}
  />
);

export default IconThumbnail;
